import format from 'date-fns/format';
import { AllArticlesPaginatedQuery_articleCollection_items_primaryImage } from 'graphql/__generated__/operations/AllArticlesPaginatedQuery';
import { BlogHeroQuery_articleCollection_items_authorsCollection_items_primaryImage } from 'graphql/__generated__/operations/BlogHeroQuery';
import { BlogHomeQuery_articleCards_items_primaryImage } from 'graphql/__generated__/operations/BlogHomeQuery';
import { placementTags } from './constants';
import { PlacementTag } from './types';

export const formatDate = (
  editorialUpdateDate: string | null | undefined,
): string => {
  if (!editorialUpdateDate) {
    return 'January 1, 1970';
  }

  return format(new Date(editorialUpdateDate), 'MMMM d, yyyy');
};

export function isPlacementTag(tag: string): tag is PlacementTag {
  return (
    tag === placementTags[0] ||
    tag === placementTags[1] ||
    tag === placementTags[2]
  );
}

export function getDescribedImage(
  image:
    | BlogHeroQuery_articleCollection_items_authorsCollection_items_primaryImage
    | BlogHomeQuery_articleCards_items_primaryImage
    | AllArticlesPaginatedQuery_articleCollection_items_primaryImage
    | null
    | undefined,
) {
  return image?.longDescribedImage || image?.describedImage || '';
}
